module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Add to Video")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Videos")]), _vm._v(" "), (_vm.sortedVideos.length > 0) ? _c('ul', _vm._l((_vm.sortedVideos), function(video) {
    return _c('VideoModalVideo', {
      key: video.id,
      attrs: {
        "id": video.id,
        "title": video.title,
        "fileID": _vm.resource,
        "cycleID": video.cycle
      },
      on: {
        "close": function($event) {
          _vm.close()
        }
      }
    })
  })) : _c('p', [_vm._v("\n        No videos found.\n      ")])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-dd5fc4c8"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddtoVideoModal.vue
// module id = 1090
// module chunks = 0